
import { Component, Mixins } from 'vue-property-decorator';
import ModalDefault from '@/components/ModalDefault/ModalDefault.vue';
import { OnboardingClass } from '@/mixins/Onboarding';

interface OnboardingStep {
  description: string;
  image?: string;
  imageAlt?: string;
}

interface OnboardingTutorial {
  pageName: string;
  name: string;
  description: string;
  steps: OnboardingStep[];
}

@Component({
  name: 'AppOnboarding',
  components: {
    ModalDefault
  }
})
export default class AppOnboarding extends Mixins(OnboardingClass) {
  private activeTutorial: OnboardingTutorial | null = null;

  private currentStepIndex = 0;

  private isModalOpen = false;

  get isDarkMode() {
    return this.$store.getters.isDarkMode;
  }

  get isOpen() {
    return this.$store.getters['Onboarding/isOpen'];
  }

  get isForced() {
    return this.$store.getters['Onboarding/isForced'];
  }

  get activeOnboardingId() {
    return this.$store.getters['Onboarding/activeOnboardingId'];
  }

  get tutorials() {
    return this.$store.getters['Onboarding/tutorials'];
  }

  get listTitle(): string {
    const tutorials = this.tutorials || [];
    return tutorials[0]?.pageName ? `Tutoriais de ${tutorials[0].pageName}` : 'Tutoriais';
  }

  handleDrawerUpdate(val: boolean) {
    if (!val) this.close();
  }

  close() {
    this.$store.dispatch('Onboarding/close');
  }

  async closeOnboarding() {
    const { isForced, activeOnboardingId } = this;
    this.close();

    if (isForced && activeOnboardingId !== null) {
      await this.updateOnboarding(activeOnboardingId);
      await this.timerUpdateProfile();
    }

    setTimeout(() => {
      this.activeTutorial = null;
      this.currentStepIndex = 0;
      this.isModalOpen = false;
    }, 300);
  }

  selectTutorial(tutorial: OnboardingTutorial) {
    this.activeTutorial = tutorial;
    this.currentStepIndex = 0;
  }

  backToList() {
    this.activeTutorial = null;
    this.currentStepIndex = 0;
  }

  openModal() {
    this.currentStepIndex = 0;
    this.isModalOpen = true;
  }

  nextStep() {
    if (this.activeTutorial && this.currentStepIndex < this.activeTutorial.steps.length - 1) {
      this.currentStepIndex += 1;
    } else {
      this.backToList();
    }
  }

  nextStepModal() {
    if (this.activeTutorial && this.currentStepIndex < this.activeTutorial.steps.length - 1) {
      this.currentStepIndex += 1;
    }
  }

  prevStep() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex -= 1;
    }
  }

  formatDescription(text: string): string {
    if (!text) return '';
    return text.replace(/"([^"]+)"/g, '<strong>$1</strong>');
  }

  onImageLoad(event: Event) {
    const target = event.target as HTMLImageElement;
    const skeleton = target.previousElementSibling;
    if (skeleton && skeleton.classList.contains('app-onboarding-static__skeleton')) {
      skeleton.remove();
    } else if (skeleton && skeleton.classList.contains('app-onboarding-modal__skeleton')) {
      skeleton.remove();
    }
  }
}
